import en from './en.translations.json.js';
import de from './de.translations.json.js';
import fr from './fr.translations.json.js';
import it from './it.translations.json.js';
import es from './es.translations.json.js';
import nl from './nl.translations.json.js';
import localizationSupportTranslationsEn from '../../mixins/localization-support/en.translations.json.js';
import localizationSupportTranslationsDe from '../../mixins/localization-support/de.translations.json.js';
import localizationSupportTranslationsFr from '../../mixins/localization-support/fr.translations.json.js';
import localizationSupportTranslationsIt from '../../mixins/localization-support/it.translations.json.js';
import localizationSupportTranslationsEs from '../../mixins/localization-support/es.translations.json.js';
import localizationSupportTranslationsNl from '../../mixins/localization-support/nl.translations.json.js';
import { uiCursorPaginationTranslationsEn, uiCursorPaginationTranslationsDe, uiCursorPaginationTranslationsFr, uiCursorPaginationTranslationsIt, uiCursorPaginationTranslationsEs, uiCursorPaginationTranslationsNl } from '../ui-cursor-pagination/index.js';

const newsListTranslationsEn = { ...en, ...localizationSupportTranslationsEn, ...uiCursorPaginationTranslationsEn };
const newsListTranslationsDe = { ...de, ...localizationSupportTranslationsDe, ...uiCursorPaginationTranslationsDe };
const newsListTranslationsFr = { ...fr, ...localizationSupportTranslationsFr, ...uiCursorPaginationTranslationsFr };
const newsListTranslationsIt = { ...it, ...localizationSupportTranslationsIt, ...uiCursorPaginationTranslationsIt };
const newsListTranslationsEs = { ...es, ...localizationSupportTranslationsEs, ...uiCursorPaginationTranslationsEs };
const newsListTranslationsNl = { ...nl, ...localizationSupportTranslationsNl, ...uiCursorPaginationTranslationsNl };
const newsListTranslationsBundle = {
  en: newsListTranslationsEn,
  de: newsListTranslationsDe,
  fr: newsListTranslationsFr,
  it: newsListTranslationsIt,
  es: newsListTranslationsEs,
  nl: newsListTranslationsNl
};

export { newsListTranslationsBundle, newsListTranslationsDe, newsListTranslationsEn, newsListTranslationsEs, newsListTranslationsFr, newsListTranslationsIt, newsListTranslationsNl };
